export enum ConfirmReason {
  NOOP = 0,
  SAVE = 1 << 0,
  BACK = 1 << 1,
  DISCARD = 1 << 2,
  CAN_CLOSE = SAVE | DISCARD,
  CANNOT_CLOSE = BACK
}
